export enum ConversationStatusEnum {
  Opened = 1,
  Pending = 2,
  Closed = 3,
  Cancelled=7,
  Declined = 6,
  Expired = 5,
  All = 4


}

export const ConversationStatusStringEnum = {
  Opened: 'Opened',
  Pending: 'Pending',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
  Declined: 'Declined',
  Expired: 'Expired',
  Processed: 'Processed',
};

export const OPPORTUNITY_CLOSED_STATUSES: string[] = [
  ConversationStatusStringEnum.Declined,
  ConversationStatusStringEnum.Cancelled,
  ConversationStatusStringEnum.Expired,
  ConversationStatusStringEnum.Closed,
];

export const OPPORTUNITY_ACTIVE_STATUSES: string[] = [
  ConversationStatusStringEnum.Opened,
  ConversationStatusStringEnum.Pending,
];

export const ConversationReasonStatusStringEnum = {
  PriceRate: 'Price/Rate',
  NoLongerInterested: 'No Longer Interested',
  DoesNotQualify: 'Does not qualify',
  NotRelevant: 'Not relevant',
  NotReadyToProceed: 'Not ready to proceed',
  BetterProductAtOFI: 'Better product at OFI',
  UnableToReach: 'Unable to Reach'
};
